import { FC, useState } from "react";
import Header from "./components/Header";
import styles from "./Mint.module.scss";
import cn from "classnames";

import { Link } from "react-router-dom";

const Mint: FC = () => {
    const [priceSniperNft] = useState(250);
    const [sniperTons] = useState(priceSniperNft.toString());
    const [priceNft] = useState(20);
    const [tons] = useState(priceNft.toString());
    const [soldNfts] = useState(0);
    const [soldSniperNfts] = useState(0);

    return (
        <section className={styles.mint}>
            <div className="container">
                <Header />
                <div className={styles.content}>
                    <div className={styles.banner}>
                        <div className={styles.text}>
                            <div className={styles.timer}>
                                <div className={styles.timeBlock}>
                                    <div className={styles.time}>0</div>
                                    <div className={styles.timeNotation}>days</div>
                                </div>
                                <div className={styles.timeBlock}>
                                    <div className={styles.time}>0</div>
                                    <div className={styles.timeNotation}>hrs</div>
                                </div>
                                <div className={styles.timeBlock}>
                                    <div className={styles.time}>0</div>
                                    <div className={styles.timeNotation}>mins</div>
                                </div>
                                <div className={styles.timeBlock}>
                                    <div className={styles.time}>0</div>
                                    <div className={styles.timeNotation}>secs</div>
                                </div>
                                <div className={cn(styles.timeBlock, styles.date)}>
                                    <div className={styles.month}>oct</div>
                                    <div className={styles.time}>4</div>
                                </div>
                            </div>
                            <h1 className={styles.mainTitle}>Minting NFT’s nest</h1>
                            <Link className={styles.button} to="/pricing">
                                <span>Read features</span>
                                <img width={9.5} height={13.5} src="/images/home/hero/arrow.svg" alt="" />
                            </Link>
                        </div>
                        <div className={styles.image}>
                            <img width={336} height={344} src="/images/mint/cards.png" alt="" />
                        </div>
                    </div>
                    <div className={styles.block}>
                        <div className={styles.top}>
                            <div className={styles.text}>
                                <h2 className={styles.title}>Fast transcation NFT</h2>
                                <p className={styles.description}>Supply: 500 NFT’s</p>
                            </div>
                            <div className={styles.price}>
                                <h3 className={styles.priceTitle}>Price</h3>
                                <div className={styles.priceValue}>
                                    <img width={18} height={18} src="/images/mint/ton.svg" alt="TON" />
                                    <span>{tons}</span>
                                </div>
                            </div>
                        </div>
                        <div className={styles.progressHolder}>
                            <div className={styles.progress} role="progressbar" aria-labelledby="progress-bar-label">
                                <span id="progress-bar-label" className="visually-hidden">
                                    Progress: {(soldNfts / 500) * 100}% Progress: {(soldNfts / 500) * 100}%
                                </span>
                                <div
                                    className={styles.progressBar}
                                    style={{ width: `${(soldNfts / 500) * 100}%` }}
                                ></div>
                            </div>
                            <div className={styles.minmax}>
                                <span>{soldNfts}</span>
                                <span>500</span>
                            </div>
                        </div>
                        {
                            /*
      <div className={styles.bottom}>
       <div className={styles.counter}>
        <button onClick={() => handleMinus(false)} className={styles.counterAction}>
         <img width={9.5} height={1.5} src="/images/mint/minus.svg" alt="" />
        </button>
        <span>{nfts} NFT</span>
        <button onClick={() => handlePlus(false)} className={styles.counterAction}>
         <img width={9.5} height={9.5} src="/images/mint/plus.svg" alt="" />
        </button>
       </div>

       {tonConnectUI.connected ? (
        <button
        onClick={async () => {
         await handleOpenBuyClick(false);
        }}
        className={styles.blockButton}
       >
        Buy
       </button>
        /*whitelist ? (
         <button className={styles.blockButtonDisabled}>In Whitelist</button>
        ) : (
         <button onClick={handleAddWhitelist} className={styles.blockButton}>
          Add to Whitelist
         </button>
        )*/
                            //) : (
                            // <></>
                            //)}
                            /*
       {tonConnectUI.connected ? (
        <button
         onClick={async () => {
          disconnectWallet();
         }}
         className={styles.blockButton}
        >
         Disconnect
        </button>
       ) : (
        <button onClick={() => handleOpenBuyClick(false)} className={styles.blockButton}>
         <span>Connect wallet</span>
        </button>
       )}
      </div>
      */
                        }
                    </div>
                    <div className={styles.block}>
                        <div className={styles.top}>
                            <div className={styles.text}>
                                <h2 className={styles.title}>Sniper mode NFT</h2>
                                <p className={styles.description}>Supply: 50 NFT’s</p>
                            </div>
                            <div className={styles.price}>
                                <h3 className={styles.priceTitle}>Price</h3>
                                <div className={styles.priceValue}>
                                    <img width={18} height={18} src="/images/mint/ton.svg" alt="TON" />
                                    <span>{sniperTons}</span>
                                </div>
                            </div>
                        </div>
                        <div className={styles.progressHolder}>
                            <div className={styles.progress} role="progressbar" aria-labelledby="progress-bar-label">
                                <span id="progress-bar-label" className="visually-hidden">
                                    Progress: {(soldSniperNfts / 50) * 100}% Progress: {(soldSniperNfts / 50) * 100}%
                                </span>
                                <div
                                    className={styles.progressBar}
                                    style={{ width: `${(soldSniperNfts / 50) * 100}%` }}
                                ></div>
                            </div>
                            <div className={styles.minmax}>
                                <span>{soldSniperNfts}</span>
                                <span>50</span>
                            </div>
                        </div>
                        {
                            /*
      <div className={styles.bottom}>
       <div className={styles.counter}>
        <button onClick={() => handleMinus(true)} className={styles.counterAction}>
         <img width={9.5} height={1.5} src="/images/mint/minus.svg" alt="" />
        </button>
        <span>{sniperNfts} NFT</span>
        <button onClick={() => handlePlus(true)} className={styles.counterAction}>
         <img width={9.5} height={9.5} src="/images/mint/plus.svg" alt="" />
        </button>
       </div>
       {tonConnectUI.connected ? (
       /*
       whitelist ? (
         <button className={styles.blockButtonDisabled}>In Whitelist</button>
        ) : (
         <button
          onClick={async () => {
           await handleAddWhitelist();
          }}
          className={styles.blockButton}
         >
          Add to Whitelist
         </button>
        )*/
                            // <button
                            //  onClick={async () => {
                            //   await handleOpenBuyClick(true);
                            //  }}
                            // className={styles.blockButton}
                            // >
                            //</div>  Buy
                            // </button>
                            //) : (
                            //  <></>
                            // )}
                            /*
       {tonConnectUI.connected ? (
        <button
         onClick={async () => {
          disconnectWallet();
         }}
         className={styles.blockButton}
        >
         Disconnect
        </button>
       ) : (
        <button onClick={() => handleOpenBuyClick(true)} className={styles.blockButton}>
         <span>Connect wallet</span>
        </button>
       )}
      </div>
       */
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Mint;
